import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import { gradientColor, products } from "./constants";

function Products() {
  return (
    <Box id="products" sx={{ marginBottom: 15 }}>
      <Typography
        variant="h4"
        sx={{
          marginLeft: "15px",
          marginRight: "15px",
          marginBottom: 5,
          textAlign: "center",
          background: gradientColor,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontWeight: "800 !important",
          fontSize: {
            xs: "1.8rem",
            md: "2.125rem",
          },
        }}
      >
        Our Product's Categories
      </Typography>
      <Grid container spacing={3}>
        {products.map((product, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                position: "relative",
                boxShadow: 5,
                borderRadius: "15px",
                overflow: "hidden",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0px 10px 15px rgba(0, 0, 0, 0.2)",
                },
              }}
            >
              <CardMedia
                component="img"
                height="200"
                image={product.img}
                alt={product.name}
                sx={{
                  filter: "brightness(0.6)",
                  transition: "filter 0.3s ease",
                  "&:hover": {
                    filter: "brightness(0.4)",
                  },
                }}
              />

              <CardContent
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  right: 0,
                  background: "rgba(0, 0, 0, 0.6)",
                  color: "#fff",
                  padding: "20px",
                  borderRadius: "0 0 15px 15px",
                  zIndex: 2,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    fontSize: "1.1rem",
                    marginBottom: 1,
                  }}
                >
                  {product.name}
                </Typography>
                <Typography variant="body2">{product.description}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Products;
